"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Creates a singleton that allows translations to be lazy-loaded when needed
 * By wrapping required translations in this helper function, we won't invoke
 * i18n.t() until needed at runtime.
 *
 * Otherwise, including strings in a Strings.ts file that invoke `i18n.t`
 * directly will all be invoked when modules are imported
 * @param stringsFn - function that returns an object containing translations
 *
 * e.g.
 * // ComponentStrings.ts
 * export default createStrings(() => ({
 *  foo: i18n.t('foo'),
 *  bar: i18n.t('bar),
 *  baz: i18n.t('baz'),
 * }))
 */
function createStrings(stringsFn) {
    var hasInvoked = false;
    var memoizedTranslations = {};
    return function () {
        if (!hasInvoked) {
            memoizedTranslations = stringsFn();
        }
        hasInvoked = true;
        return memoizedTranslations;
    };
}
exports.default = createStrings;
